module.exports = __webpack_public_path__ + "img/imagem-04-detalhada-palmeiras-04.096870bd.png";